function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M397.875985,85.613449 C398.109685,85.3797488 398.109685,85.0009212 397.875985,84.767221 C397.642584,84.5335208 397.263158,84.5335208 397.029757,84.767221 L393,88.796978 L388.970841,84.767221 C388.737441,84.5335208 388.358314,84.5335208 388.124613,84.767221 C387.890913,85.0009212 387.890913,85.3797488 388.124613,85.613449 L392.153772,89.643206 L387.876849,93.9201286 C387.643149,94.1538288 387.643149,94.5326564 387.876849,94.7663566 C387.99355,94.8833563 388.146757,94.9417066 388.299963,94.9417066 C388.45317,94.9417066 388.606377,94.8833563 388.723077,94.7663566 L393,90.489434 L397.276923,94.7663566 C397.393922,94.8833563 397.54683,94.9417066 397.700037,94.9417066 C397.853243,94.9417066 398.006151,94.8833563 398.123151,94.7663566 C398.356851,94.5326564 398.356851,94.1538288 398.123151,93.9201286 L393.846228,89.643206 L397.875985,85.613449 Z",
  id: "Shape",
  stroke: "none",
  fill: "#000000",
  fillRule: "evenodd"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "387 84 12 11",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.1753013a.svg";
export { ForwardRef as ReactComponent };